const CLOUDINARY_ROUTE_START = 'res.cloudinary.com'
const CLOUDINARY_BASE_PATH = `https://${CLOUDINARY_ROUTE_START}/benchmarkminerals`
const CLOUDINARY_PATH = `${CLOUDINARY_BASE_PATH}/image/upload`

const CLOUDINARY_MODIFIERS_BY_DEFAULT = [
  'f_avif',
  'q_auto',
  'g_auto',
  'dpr_auto',
]

const CLOUDINARY_QUERY_STRINGS = '?_i=AA'

type TCloudinaryBuildRoute = {
  imageUrl: string
  modifiers: string[]
  hasDefaultModifiers?: boolean
  modifiersExtra?: string[]
}

export function cloudinaryBuildRoute({
  imageUrl,
  modifiers,
  hasDefaultModifiers = true,
  modifiersExtra = [],
}: TCloudinaryBuildRoute): string {
  if (hasDefaultModifiers) {
    const transformationsDefault = Array.from(
      new Set([...CLOUDINARY_MODIFIERS_BY_DEFAULT, ...modifiersExtra]),
    ).join(',')
    const transformations = modifiers.join(',')
    if (transformations) {
      return `${CLOUDINARY_PATH}/${transformations}/${transformationsDefault}/${imageUrl}${CLOUDINARY_QUERY_STRINGS}`
    }
    return `${CLOUDINARY_PATH}/${transformationsDefault}/${imageUrl}${CLOUDINARY_QUERY_STRINGS}`
  }

  const transformations = modifiers.join(',')

  if (modifiersExtra.length) {
    const transformationsExtra = modifiersExtra.join(',')
    return `${CLOUDINARY_PATH}/${transformations}/${transformationsExtra}/${imageUrl}${CLOUDINARY_QUERY_STRINGS}`
  }

  return `${CLOUDINARY_PATH}/${transformations}/${imageUrl}${CLOUDINARY_QUERY_STRINGS}`
}
